// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2JjlE","footer":"Form_footer__3EQyG"};